import { ReactElement } from "react";
import { Container, Typography, Box, Divider } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

// components
import { BannerSection } from "./components/Banner_DataHub";
import ImgDev1 from "./imgs/dev_1.png";
import ImgDev2 from "./imgs/dev_2.png";
import ImgDev3 from "./imgs/dev_3.png";
import ImgDev4 from "./imgs/dev_4.png";
import ImgDev5 from "./imgs/dev_5.png";


const ProdDataHubPage = (): ReactElement => {

  return (
    <>
      <BannerSection />
      <Container sx={{ my: 1, p: 5, maxWidth: "1170px", }}>
        <Grid container spacing={2} sx={{ mx: 'auto', justifyContent: "center", maxWidth: '860px', minHeight: '500px' }}>
          <Grid sm={12} xs={12}>
            <Typography component="div" sx={{ fontSize: '32px', fontWeight: 800, color: '#3F51B5', }}>システム開発の流れ</Typography>
          </Grid>
          <Grid sm={6} xs={12}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '20px', fontWeight: 400, color: '#303030', }}>1.要件定義</Typography>
              <Divider />
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                システム開発の最初のステップであり、
                システムがカバーする範囲や、実現方法などを決定し、システムの大まかな仕様を「システム要件」として定義します。
                <br />
                <br />
                以降のステップはすべて、この「システム要件」を満たすために実行されます。ここでしっかりと要件を定義しておかないと、後に大きなスケジュールの遅れや、コストの増加など、問題が起きる場合があります。
                <br />
                <br />
                要件定義ではまず、ユーザーにヒアリングを行います。その結果を踏まえ、「システム要件」を定義した「要件定義書」を作成します。
                <br />
                <br />
                経営陣に対してはビジネス上の課題や今後の展望について、システム管理部門に対しては現状のシステム構成や使用しているツールなどについてヒアリングします。また、業務部門に対して、現状の業務内容や業務フロー、困りごとをヒアリングする場合もあります。              </Typography>
            </Box>
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box
              component="img"
              src={ImgDev1}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={6} xs={12}>
            <Box
              component="img"
              src={ImgDev2}
              sx={{ textAlign: 'center', width: 350, }}
            />
          </Grid>
          <Grid sm={6} xs={12} sx={{ display: { sm: 'block', xs: 'none' } }}>
            <Box sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
              <Typography component="div" sx={{ fontSize: '20px', fontWeight: 400, color: '#303030', }}>
                2.スケジュール設計
              </Typography>
              <Divider />
              <Typography component="div" sx={{ fontSize: '14px', fontWeight: 400, color: '#303030', }}>
                スケジュール、マイルストンを設定します。
                <br />
                <br />

              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ProdDataHubPage;
